import React, { useState, useRef, useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import {
  convertToHTML,
  fetchData,
  getAPIEndpoint,
  getCookie,
  getMessage,
  getQuestions,
  setCookie,
  copyContent,
  isMobile,
  addProductCategory,
} from "./Utils";
import ChatIcon from "./icon.png";
import HeaderBG from "./header.png";
import SendIcon from "./send.svg";
import PhoneIcon from "./phone.svg";
import Input from "./Input";

const Questions = ({ token, message, setMessage, handleSendMessage }) => {
  const questions = getQuestions(token);

  useEffect(() => {
    if (message) {
      let checkMessageClick = false;
      for (let index = 0; index < questions.length; index++) {
        if (questions[index] === message) {
          checkMessageClick = true;
        }
      }
      if (checkMessageClick) handleSendMessage();
    }
  }, [message]);

  const submitQuestion = (que) => {
    setMessage(que);
  };

  return (
    <ul className="questions">
      {questions.map((question, index) => (
        <li key={index} onClick={() => submitQuestion(question)}>
          <img src="/agent/elec.svg" />
          <div>{question}</div>
        </li>
      ))}
    </ul>
  );
};

const SupportHTML = ({ token }) => {
  let support = {
    phone: "18001216808",
    phone2: "1800120332222",
    email: "service@jaquar.com",
  };

  if (token === "glen") {
    support = {
      phone: "+919266655555",
      phone2: "+919717156666",
      email: "enquiry@glenindia.com",
    };
  }

  return (
    <ul className="p-block">
      <li>
        <a href={`tel:${support.phone}`}>
          <div className="grid">
            <label>Support</label>
            <div className="message">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                  stroke="#79747E"
                />
              </svg>{" "}
              {support.phone}
            </div>
          </div>
        </a>
        <a role="button" onClick={() => copyContent(support.phone)}>
          <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path
              d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
              fill="#8F8F8F"
            />
          </svg>
        </a>
      </li>
      <li>
        <a href={`tel:${support.phone2}`}>
          <div className="grid">
            <label>Sales</label>
            <div className="message">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                  stroke="#79747E"
                />
              </svg>{" "}
              {support.phone2}
            </div>
          </div>
        </a>
        <a role="button" onClick={() => copyContent(support.phone2)}>
          <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path
              d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
              fill="#8F8F8F"
            />
          </svg>
        </a>
      </li>
      <li>
        <a href={`mailto:${support.email}`}>
          <div className="grid">
            <label>Email</label>
            <div className="message">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect
                  x="2.66669"
                  y="4"
                  width="10.6667"
                  height="8"
                  rx="2"
                  stroke="#79747E"
                />
                <path
                  d="M2.66669 6L7.10559 8.21945C7.66865 8.50098 8.33139 8.50098 8.89445 8.21945L13.3334 6"
                  stroke="#79747E"
                />
              </svg>{" "}
              {support.email}
            </div>
          </div>
        </a>
        <a role="button" onClick={() => copyContent(support.email)}>
          <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
            <path
              d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
              fill="#8F8F8F"
            />
          </svg>
        </a>
      </li>
    </ul>
  );
};

const QuestionsNew = ({
  token,
  urlenv,
  message,
  setMessage,
  setMessages,
  getCurrentTime,
  handleSendMessage,
  sessionData,
  threadId,
  scrollToBottom,
  from,
}) => {
  const [questionClicked, setQuestionClicked] = useState(false);

  const submitQue = (text) => {
    switch (text) {
      case "product":
        // setQuestionClicked(true);
        // handleSendMessage(undefined, "Show Products");

        const html = `<p>Essco Bathware offers a complete range of affordable, high-quality bathroom solutions tailored to diverse needs. Our products include:<br/><br/>1.⁠ ⁠Faucets – Stylish, functional designs for every bathroom.<br/>2.⁠ ⁠Showers – From overhead to hand showers for a refreshing experience.<br/>3.⁠ ⁠Sanitaryware – Wash basins, closets, and urinals that blend style and utility.<br/>4.⁠ ⁠Cisterns – Durable, water-saving flushing systems.<br/>5.⁠ ⁠Allied Items – Functional add-ons like angle valves and stop cocks.<br/>6.⁠ ⁠Accessories – Towel shelf, soap dishes, robe hooks, and more.<br/>7.⁠ ⁠Water Heaters – Energy-efficient options for reliable hot water.<br/><br/>Crafted for value and performance, Essco products are ideal for a wide range of users.<br/><br/>You can check our complete list of products here: <a href="https://www.esscobathware.com/products" target="_blank">All Products <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a><br/><br/>If you need further assistance, feel free to ask!`;

        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "View Product Brochure",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: html,
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "View Product Brochure",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);

        break;
      case "dealer":
        setQuestionClicked(true);
        handleSendMessage(undefined, "Find dealers near me");
        break;
      case "brochure": {
        const html = `<p>Sure. You can check our product brochure here: <a href="https://www.catalogue.esscobathware.com/essco-new-catalogue/page/1" target="_blank">View Product Brochure <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;

        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "View Product Brochure",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: html,
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "View Product Brochure",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "warranty": {
        const html = `<p>To protect your purchase with warranty coverage, you can register your product here: <a href="https://support.jaquar.com/Warranty/Validate" target="_blank">Register for warranty <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;

        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Register for warranty",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: html,
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Register for warranty",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "service_request": {
        const html = `<p>To register a service request for your product, please visit: <a href="https://support.jaquar.com/Service/Support" target="_blank">Support <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;
        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Register a service request",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: html,
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Register a service request",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "assistant": {
        const html = (
          <div className="support">
            <p>
              If you need any help with a new purchase, we're just a call away.{" "}
              <br />
              <br />
              Feel free to reach out to us anytime between Monday-Saturday 9:00
              AM to 6:00 PM.
            </p>
            <ul className="p-block">
              <li onClick={() => copyContent("1800 121 6808")}>
                <div className="grid">
                  <label>Support</label>
                  <div className="message">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path
                        d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                        stroke="#79747E"
                      />
                    </svg>{" "}
                    1800 121 6808
                  </div>
                </div>
                <a role="button">
                  <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
                    <path
                      d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
                      fill="#8F8F8F"
                    />
                  </svg>
                </a>
              </li>
              <li onClick={() => copyContent("1800 120 33 2222")}>
                <div className="grid">
                  <label>Sales</label>
                  <div className="message">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path
                        d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                        stroke="#79747E"
                      />
                    </svg>{" "}
                    1800 120 33 2222
                  </div>
                </div>
                <a role="button">
                  <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
                    <path
                      d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
                      fill="#8F8F8F"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <br />
            If you need further assistance, feel free to ask!
          </div>
        );

        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Call a purchase assistant",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: ReactDOMServer.renderToString(html),
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Call a purchase assistant",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: html,
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "customer_support": {
        // const chtml = sessionData.settings.contact_response;
        // console.log("🚀 ~ submitQue ~ html:", chtml);
        const html = (
          <div className="support">
            <p>
              For after-sales support, service requests, or complaint
              registration, you can reach out to our customer care team, where a
              human customer care executive will assist you. <br />
              <br />
              Note: Customer Care Executives are available Monday-Saturday 9:00
              AM to 6:00 PM.
            </p>
            <SupportHTML />
            <br />
            If you need further assistance, feel free to ask!
          </div>
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Call a purchase assistant",
            sender_type: "user",
          },
          true
        );
        setTimeout(() => {
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: ReactDOMServer.renderToString(html),
              sender_type: "agent",
            },
            true
          );
        }, 500);

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Contact customer support",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: html,
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      default:
        break;
    }

    setTimeout(() => {
      scrollToBottom();
    }, 500);
  };

  const htmlBtn = (
    <div>
      <div className="chatbox-message-item-text mt-2">
        Find Product Information
      </div>
      <ul className="questions">
        <li onClick={() => submitQue("product")}>
          <img src="/agent/elec.svg" />
          <div>Show Products</div>
        </li>
        <li onClick={() => submitQue("brochure")}>
          <img src="/agent/elec.svg" />
          <div>View Product Brochure</div>
        </li>
      </ul>
      <div className="chatbox-message-item-text">Get Help & Assistance</div>
      <ul className="questions">
        <li onClick={() => submitQue("assistant")}>
          <img src="/agent/question.svg" />
          <div>Call a purchase assistant</div>
        </li>
        <li onClick={() => submitQue("customer_support")}>
          <img src="/agent/question.svg" />
          <div>Contact customer support</div>
        </li>
        <li onClick={() => submitQue("dealer")}>
          <img src="/agent/question.svg" />
          <div>Find dealers near me</div>
        </li>
      </ul>
      <div className="chatbox-message-item-text">
        Register Warranty or Service Request
      </div>
      <ul className="questions">
        <li onClick={() => submitQue("warranty")}>
          <img src="/agent/setting.svg" />
          <div>Register for warranty</div>
        </li>
        <li onClick={() => submitQue("service_request")}>
          <img src="/agent/setting.svg" />
          <div>Register a service request</div>
        </li>
      </ul>
    </div>
  );

  useEffect(() => {
    if (message && questionClicked) {
      setQuestionClicked(false);
    }
  }, [message, questionClicked]);

  return htmlBtn;
};

const ChatAnswer = ({ msg, urlenv, token }) => {
  // console.log("🚀 ~ ChatAnswer ~ msg:", msg);
  const [alreadyReviewed, setAlreadyReviewed] = useState([]);
  const [isLiked, setIsLiked] = useState(false);

  useEffect(() => {
    if (isLiked) {
      const timer = setTimeout(() => {
        setIsLiked(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isLiked]);

  useEffect(() => {
    // Initialize window.alreadyReviewed if it doesn't exist
    window.alreadyReviewed = window.alreadyReviewed || [];
    if (msg.rating === "up" || msg.rating === "down") {
      window.alreadyReviewed.push({
        document_id: msg.document_id,
        rating: msg.rating,
      });
    }
    setTimeout(() => {
      setAlreadyReviewed([...window.alreadyReviewed]);
    }, 2000);
  }, []);

  const handleReview = (msg, type) => {
    // Add review to window object and state with rating type
    const reviewData = {
      document_id: msg.document_id,
      rating: type,
    };
    window.alreadyReviewed.push(reviewData);
    setAlreadyReviewed([...window.alreadyReviewed]);
    setIsLiked(true);
    // Make API call
    fetchData(
      token,
      `${getAPIEndpoint(token, urlenv, true)}/chat-message/vote`,
      {
        documentId: msg.document_id,
        vote: type,
      },
      true
    );
  };

  const isReviewed = alreadyReviewed.some(
    (review) => review.document_id === msg.document_id
  )
    ? "reviewed"
    : "";

  return (
    <div className="chat-answer">
      {msg.text}
      {msg.document_id && (
        <div className="chat-answer-review">
          {isLiked && (
            <span
              className={`review-status ${
                alreadyReviewed.some(
                  (review) =>
                    review.document_id === msg.document_id &&
                    review.rating === "up"
                )
                  ? "up active"
                  : "down active"
              }`}
            >
              {alreadyReviewed.some(
                (review) =>
                  review.document_id === msg.document_id &&
                  review.rating === "up"
              )
                ? "Upvoted"
                : "Flagged"}
            </span>
          )}
          <a
            role="button"
            onClick={() => (isReviewed ? {} : handleReview(msg, "up"))}
            className={`${isReviewed} ${
              alreadyReviewed.some(
                (review) =>
                  review.document_id === msg.document_id &&
                  review.rating === "up"
              )
                ? "up active"
                : ""
            }`}
          >
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path
                d="M6.094 0.0316829C5.43675 -0.13263 4.82625 0.364433 4.78225 1.00793C4.73275 1.7305 4.62413 2.39393 4.488 2.78856C4.40206 3.03606 4.15869 3.485 3.773 3.91537C3.39006 4.34368 2.89163 4.72525 2.30794 4.88475C1.84594 5.01056 1.375 5.41068 1.375 5.99506V8.74574C1.375 9.32668 1.84387 9.75224 2.3705 9.80793C3.10612 9.88631 3.44575 10.0932 3.79225 10.305L3.82525 10.3256C4.01225 10.4391 4.22263 10.5649 4.49213 10.6584C4.76506 10.7519 5.08406 10.8076 5.5 10.8076H7.90625C8.55044 10.8076 9.00556 10.4796 9.23588 10.0761C9.34719 9.88562 9.40734 9.66962 9.4105 9.44906C9.4105 9.34456 9.39469 9.23456 9.35756 9.13006C9.49575 8.94925 9.61881 8.73268 9.69306 8.51062C9.76869 8.28374 9.81131 7.98674 9.69581 7.72068C9.74325 7.63131 9.77831 7.53575 9.80513 7.44362C9.85806 7.258 9.88281 7.05312 9.88281 6.85443C9.88281 6.65643 9.85806 6.45225 9.80513 6.26593C9.78108 6.18028 9.74932 6.09698 9.71025 6.01706C9.83063 5.84578 9.90808 5.64808 9.93608 5.44062C9.96408 5.23315 9.9418 5.02199 9.87113 4.82493C9.7295 4.41793 9.40225 4.06868 9.04612 3.95043C8.46381 3.75656 7.80656 3.76068 7.31638 3.80537C7.21461 3.81453 7.11306 3.82599 7.01181 3.83975C7.25031 2.81839 7.23568 1.75422 6.96919 0.739808C6.92282 0.577275 6.83388 0.430079 6.71157 0.313441C6.58925 0.196803 6.43799 0.114958 6.27344 0.0763704L6.094 0.0316829ZM7.90625 10.1207H5.5C5.14937 10.1207 4.90669 10.0733 4.71625 10.008C4.52306 9.94131 4.36838 9.85124 4.18275 9.73781L4.15525 9.72131C3.77369 9.48825 3.33162 9.21875 2.44337 9.12456C2.21444 9.09981 2.0625 8.92518 2.0625 8.74643V5.99506C2.0625 5.82043 2.21787 5.62175 2.48875 5.54818C3.24156 5.34193 3.84794 4.86343 4.28588 4.37393C4.72244 3.88581 5.01737 3.35987 5.137 3.01406C5.30406 2.53281 5.41681 1.79856 5.46838 1.05468C5.48556 0.805808 5.71588 0.646308 5.92694 0.698558L6.10706 0.743933C6.21706 0.771433 6.28444 0.842245 6.30506 0.919245C6.58583 1.98901 6.55121 3.11715 6.20538 4.16768C6.1858 4.22611 6.18229 4.28873 6.19521 4.34898C6.20814 4.40923 6.23702 4.4649 6.27884 4.51016C6.32065 4.55542 6.37387 4.5886 6.43291 4.60625C6.49195 4.62389 6.55465 4.62533 6.61444 4.61043L6.6165 4.60975L6.62612 4.60768L6.666 4.59806C6.90109 4.54813 7.13892 4.51209 7.37825 4.49012C7.83406 4.44887 8.37994 4.453 8.82888 4.60287C8.94919 4.64275 9.13825 4.80912 9.22075 5.04975C9.29431 5.2615 9.28056 5.51037 9.03788 5.75237L8.79519 5.99506L9.03788 6.23843C9.06744 6.268 9.11006 6.33537 9.14375 6.455C9.17675 6.56981 9.19531 6.70937 9.19531 6.85443C9.19531 7.00018 9.17675 7.13906 9.14375 7.25456C9.10938 7.37418 9.06744 7.44156 9.03788 7.47112L8.79519 7.71381L9.03788 7.95718C9.07019 7.9895 9.11281 8.07887 9.04131 8.29268C8.96681 8.50002 8.84838 8.68881 8.69413 8.84612L8.45144 9.08881L8.69413 9.33218C8.69825 9.33562 8.72231 9.36656 8.72231 9.44906C8.71926 9.5499 8.69064 9.64831 8.63912 9.73506C8.52569 9.93306 8.29331 10.1207 7.90625 10.1207Z"
                fill="#999999"
              />
            </svg>
          </a>
          <a
            role="button"
            className={`${isReviewed} ${
              alreadyReviewed.some(
                (review) =>
                  review.document_id === msg.document_id &&
                  review.rating === "down"
              )
                ? "down active"
                : ""
            }`}
            onClick={() => (isReviewed ? {} : handleReview(msg, "down"))}
          >
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path
                d="M6.094 10.7759C5.43675 10.9409 4.82694 10.4431 4.78225 9.79962C4.73275 9.07775 4.62413 8.41431 4.488 8.019C4.40206 7.7715 4.15869 7.32325 3.773 6.89287C3.39006 6.46387 2.89163 6.08231 2.30794 5.9235C1.84594 5.797 1.375 5.39687 1.375 4.8125V2.0625C1.375 1.48156 1.84388 1.056 2.3705 0.999625C3.10613 0.921937 3.44575 0.714312 3.79225 0.502562L3.82525 0.482625C4.01225 0.3685 4.22263 0.242687 4.49213 0.149875C4.76506 0.055 5.08406 0 5.5 0H7.90625C8.55044 0 9.00556 0.328625 9.23588 0.7315C9.34863 0.928812 9.4105 1.14881 9.4105 1.35919C9.4105 1.46369 9.39469 1.57369 9.35756 1.67819C9.49575 1.85831 9.61881 2.07487 9.69306 2.29694C9.76869 2.52381 9.81131 2.82081 9.69581 3.08756C9.74325 3.17694 9.77831 3.27181 9.80513 3.36462C9.85806 3.55025 9.88281 3.75444 9.88281 3.95312C9.88281 4.15181 9.85806 4.356 9.80513 4.54162C9.78106 4.62412 9.75013 4.70937 9.71025 4.79119C9.98113 5.18375 9.99763 5.61619 9.87113 5.98262C9.7295 6.38962 9.40225 6.73887 9.04613 6.85712C8.46381 7.05169 7.80656 7.04687 7.31638 7.00219C7.21461 6.99302 7.11306 6.98156 7.01181 6.96781C7.25045 7.98939 7.23582 9.05381 6.96919 10.0684C6.87431 10.4177 6.59106 10.6514 6.27344 10.7312L6.094 10.7759ZM7.90625 0.6875H5.5C5.14938 0.6875 4.90669 0.73425 4.71625 0.799562C4.52306 0.86625 4.36838 0.957 4.18275 1.06975L4.15525 1.08694C3.77369 1.31931 3.33163 1.58881 2.44337 1.68369C2.21444 1.70775 2.0625 1.88306 2.0625 2.06181V4.8125C2.0625 4.98781 2.21788 5.18581 2.48875 5.25937C3.24156 5.46562 3.84794 5.94481 4.28588 6.43431C4.72244 6.92244 5.01738 7.44837 5.137 7.7935C5.30406 8.27475 5.41681 9.009 5.46838 9.75287C5.48556 10.0017 5.71588 10.1619 5.92694 10.109L6.10706 10.0643C6.21706 10.0368 6.28444 9.96531 6.30506 9.889C6.58596 8.81902 6.55134 7.69062 6.20538 6.63987C6.18596 6.58149 6.18258 6.51896 6.19558 6.45881C6.20857 6.39867 6.23748 6.34312 6.27927 6.29796C6.32106 6.25279 6.37421 6.21968 6.43316 6.20206C6.49212 6.18445 6.55472 6.18298 6.61444 6.19781H6.6165L6.62613 6.20056L6.666 6.2095C6.90109 6.25942 7.13892 6.29546 7.37825 6.31744C7.83406 6.35869 8.37994 6.35456 8.82888 6.20537C8.94919 6.16481 9.13825 5.99844 9.22075 5.75781C9.29431 5.54606 9.28056 5.29719 9.03788 5.05587L8.79519 4.8125L9.03788 4.56912C9.06744 4.54025 9.11006 4.47287 9.14375 4.35256C9.17675 4.23775 9.19531 4.09819 9.19531 3.95312C9.19531 3.80806 9.17675 3.6685 9.14375 3.55369C9.10938 3.43406 9.06744 3.366 9.03788 3.33712L8.79519 3.09375L9.03788 2.85037C9.07019 2.81806 9.11281 2.72937 9.04131 2.51487C8.96672 2.30778 8.84829 2.11924 8.69413 1.96212L8.45144 1.71875L8.69413 1.47537C8.69825 1.47194 8.72231 1.441 8.72231 1.3585C8.71915 1.25789 8.69053 1.15973 8.63913 1.07319C8.525 0.8745 8.29331 0.6875 7.90625 0.6875Z"
                fill="#999999"
              />
            </svg>
          </a>
        </div>
      )}
    </div>
  );
};

function Chatbox() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const urlenv =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("staging")
      ? "staging"
      : "production";

  const [leadArr, setLeadArr] = useState([]);
  const [leadFormStart, setleadFormStart] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [loader, setLoader] = useState(false);
  const [sessionData, setSessionData] = useState();
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [threadId, setThreadId] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatboxRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // setTimeout(() => {
      //   chatboxRef.current?.classList.add("show");
      // }, 100);
      window.parent.postMessage("openChat", "*");
      if (!threadId) {
        createThread();
      }
    } else {
      // chatboxRef.current?.classList.remove("show");
      // setTimeout(() => {
      window.parent.postMessage("closeChat", "*");
      // }, 300);
    }

    if ((token === "essco" || token === "glen") && isOpen) {
      const scriptId = "plausible-analytics-script";
      if (!document.getElementById(scriptId)) {
        const s = document.createElement("script");
        s.id = scriptId;
        s.type = "text/javascript";
        s.defer = true;
        s.src = "https://plausible.io/js/script.manual.js";
        s.setAttribute("data-domain", "agilisplus.ai");
        document.getElementsByTagName("head")[0].appendChild(s);
        s.onload = () => {
          window.plausible =
            window.plausible ||
            function () {
              (window.plausible.q = window.plausible.q || []).push(arguments);
            };

          window.plausible("pageview", {
            props: { token: token || "unknown" },
          });
        };
      }
    }
  }, [isOpen]);

  useEffect(() => {
    scrollToBottom();
  }, [message]);

  useEffect(() => {
    if (
      messages &&
      messages[messages.length - 1] &&
      messages[messages.length - 1].lead &&
      messages[messages.length - 1].value
    ) {
      startTakingLead();
    }
  }, [messages]);

  const startTakingLead = () => {
    const leadForm = sessionData.settings.lead_form;
    const currentLead = leadForm[leadArr.length];
    if (currentLead) {
      const value =
        sessionData.data.lead && sessionData.data.lead[currentLead.fld_name]
          ? sessionData.data.lead[currentLead.fld_name]
          : "";

      setMessages((prev) => [
        ...prev,
        {
          text: (
            <div
              className=""
              dangerouslySetInnerHTML={{
                __html: currentLead.caption_text,
              }}
            />
          ),
          type: "received",
          lead: true,

          value,
          time: getCurrentTime(),
          ...currentLead,
        },
      ]);
      setLeadArr([...leadArr, ...[leadForm.fld_name]]);
    } else {
      setMessages((prev) => [
        ...prev,
        {
          text: (
            <div
              className=""
              dangerouslySetInnerHTML={{
                __html: sessionData.settings.lead_thanks,
              }}
            />
          ),
          type: "received",
          time: getCurrentTime(),
        },
      ]);
      setleadFormStart(false);
    }
    setTimeout(() => {
      scrollToBottom();
    }, 500);
  };

  useEffect(() => {
    if (
      sessionData &&
      currentQuestionIndex == sessionData.settings.lead_trigger_position
    ) {
      setleadFormStart(true);
      startTakingLead();
    }
  }, [currentQuestionIndex]);

  useEffect(() => {
    // console.log("🚀 ~ useEffect ~ messages:", messages);
    if (
      threadId &&
      (messages.length === 1 || messages.length === 2) &&
      token === "essco"
    ) {
      let alreadypushed = false;
      if (
        messages.length === 2 &&
        messages[0].text &&
        messages[0].text.props &&
        messages[0].text.props.className === "questions-block"
      ) {
        alreadypushed = true;
      }

      if (!alreadypushed) {
        setMessages((prev) => [
          {
            text: (
              <div className="questions-block">
                <div class="chatbox-message-item-text">
                  Hello, I am your virtual assistant. How may I help you today?
                  <br />
                </div>
                <QuestionsNew
                  message={message}
                  setMessage={setMessage}
                  handleSendMessage={handleSendMessage}
                  token={token}
                  urlenv
                  setMessages={setMessages}
                  getCurrentTime={getCurrentTime}
                  sessionData={sessionData}
                  threadId={threadId}
                  scrollToBottom={scrollToBottom}
                />
              </div>
            ),
            type: "received",
            time: getCurrentTime(),
          },
          ...prev,
        ]);
      }
    }
  }, [threadId, messages]);

  const saveSession = async (saveSessionResp) => {
    const data = await saveSessionResp.json();
    setLoader(false);
    if (data.data) {
      setSessionData(data);
      if (data.data.chat_messages) {
        const chatM = [];
        for (let index = 0; index < data.data.chat_messages.length; index++) {
          const chat = data.data.chat_messages[index];
          chatM.push({
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{ __html: chat.message }}
              />
            ),
            type: chat.sender_type === "agent" ? "received" : "sent",
            time: getCurrentTime(chat.createdAt),
            document_id: chat.documentId,
            rating:
              chat.rating === 1
                ? "up"
                : chat.rating === -1
                ? "down"
                : undefined,
          });
        }
        setCurrentQuestionIndex(chatM.length);
        setMessages(chatM.reverse());
      }
    }
  };

  // Create a thread when chat opens
  const createThread = async () => {
    try {
      const threadIDCookie = getCookie(`thread_v1_id_${token}`);
      // console.log("🚀 ~ createThread ~ threadIDCookie:", threadIDCookie);

      // const threadIDCookie = "1234";

      // fetchData(
      //   token,
      //   `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
      //   {
      //     session_id: 'test',
      //     message: 'test',
      //     sender_type: "user",
      //   },
      //   true
      // );

      if (!threadIDCookie) {
        const response = await fetch(
          `${getAPIEndpoint(token, urlenv)}/create_thread`,
          {
            method: "POST",
          }
        );
        const data = await response.json();
        if (data.thread_id) {
          setThreadId(data.thread_id);
          setCookie(`thread_v1_id_${token}`, data.thread_id, 1);

          const saveSessionResp = await fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/session-save`,
            {
              session_id: data.thread_id,
            },
            true
          );
          if (saveSessionResp) saveSession(saveSessionResp);
        }
      } else {
        setLoader(true);
        setThreadId(threadIDCookie);
        setCookie(`thread_v1_id_${token}`, threadIDCookie, 1);
        const saveSessionResp = await fetchData(
          token,
          `${getAPIEndpoint(token, urlenv, true)}/session/session-save`,
          {
            session_id: threadIDCookie,
          },
          true
        );
        if (saveSessionResp) saveSession(saveSessionResp);
      }
    } catch (error) {
      console.error("Error creating thread:", error);
    }
  };

  const isValid = (text) => text.trim().length > 0;

  function containsWholeWord(text) {
    const keywords = [
      "hi",
      "hello",
      "good morning",
      "good evening",
      "hey",
      "greetings",
      "namaste",
      "how are you",
    ];
    const pattern =
      "\\b(" +
      keywords
        .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|") +
      ")\\b";
    const regex = new RegExp(pattern, "i"); // "i" for case-insensitive
    return regex.test(text);
  }

  // Send message to API
  const handleSendMessage = async (e, localMessage = "") => {
    if (e) e.preventDefault();
    const textMessage = localMessage || message;
    if (isValid(textMessage) && !isTyping) {
      setMessage("");
      const time = getCurrentTime();
      let newMessage = [];

      newMessage.push({ text: textMessage, type: "sent", time });
      // console.log("🚀 ~ handleSendMessage ~ newMessage:", newMessage);

      setMessages((prev) => [...prev, ...newMessage]);
      setMessage("");
      setIsTyping(true);

      fetchData(
        token,
        `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
        {
          session_id: threadId,
          message: textMessage,
          sender_type: "user",
        },
        true
      );
      try {
        const check = containsWholeWord(textMessage);
        if (check && token === "essco") {
          setIsTyping(false);
          setCurrentQuestionIndex(currentQuestionIndex + 1);
          fetchData(
            token,
            `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
            {
              session_id: threadId,
              message:
                "Hello, I am your virtual assistant. How may I help you today?<br/>Please select option from below<br/>",
              sender_type: "agent",
            },
            true
          );
          setMessages((prev) => [
            ...prev,
            {
              text: (
                <>
                  <div
                    className="chatbox-message-item-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        "Hello, I am your virtual assistant. How may I help you today?<br/>Please select option from below<br/>",
                    }}
                  />
                  <QuestionsNew
                    message={textMessage}
                    setMessage={setMessage}
                    handleSendMessage={handleSendMessage}
                    token={token}
                    setMessages={setMessages}
                    getCurrentTime={getCurrentTime}
                    sessionData={sessionData}
                    threadId={threadId}
                    scrollToBottom={scrollToBottom}
                  />
                </>
              ),
              type: "received",
              time: getCurrentTime(),
            },
          ]);
        } else {
          const response = await fetch(
            `${getAPIEndpoint(
              token,
              urlenv
            )}/chat-new?question_index=${currentQuestionIndex}&draft_save=true`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                thread_id: threadId,
                message: textMessage,
              }),
            }
          );

          if (response.status === 200) {
            const data = await response.json();
            const respMessage =
              addProductCategory(data) || "No response received";
            if (data.draft_data.documentId) {
              fetchData(
                token,
                `${getAPIEndpoint(
                  token,
                  urlenv,
                  true
                )}/session/chat-update-publish`,
                {
                  documentId: data.draft_data.documentId,
                  session_id: threadId,
                  message: respMessage.htmlString,
                  sender_type: "agent",
                },
                true
              );
            }
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setMessages((prev) => [
              ...prev,
              {
                text: respMessage.html,
                type: "received",
                time: getCurrentTime(),
                document_id: data.draft_data.documentId,
              },
            ]);
          } else {
            setMessages((prev) => [
              ...prev,
              {
                text: "There is some error during fetching a response.",
                type: "received",
                time: getCurrentTime(),
              },
            ]);
          }

          setIsTyping(false);
          setTimeout(() => {
            scrollToBottom();
          }, 500);
        }
      } catch (error) {
        console.error("Error sending message:", error);
        setMessages((prev) => [
          ...prev,
          {
            text: "There is some error during fetching a response.",
            type: "received",
            time: getCurrentTime(),
          },
        ]);

        setIsTyping(false);
        setTimeout(() => {
          scrollToBottom();
        }, 500);
      }
    }
  };

  const scrollToBottom = () => {
    if (contentRef.current) {
      const allSentMessage = contentRef.current.querySelectorAll(
        ".chatbox-message-item.sent"
      );
      const lastSentMessage = allSentMessage[allSentMessage.length - 1];
      console.log("🚀 ~ scrollToBottom ~ lastSentMessage:", lastSentMessage);
      if (lastSentMessage) {
        lastSentMessage.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        contentRef.current.scrollTop = contentRef.current.scrollHeight;
      }
    }
  };

  const getCurrentTime = (dateString = null) => {
    const today = dateString ? new Date(dateString) : new Date();

    return (
      String(today.getHours()).padStart(2, "0") +
      ":" +
      String(today.getMinutes()).padStart(2, "0")
    );
  };

  const submitContact = () => {
    // const html = sessionData.settings.contact_response;
    const html = (
      <div className="support">
        <p>Want to get in touch right away?</p>
        <SupportHTML token={token} />
      </div>
    );
    setMessages((prev) => [
      ...prev,
      {
        text: html,
        type: "received",
        time: getCurrentTime(),
      },
    ]);

    fetchData(
      token,
      `${getAPIEndpoint(token, urlenv, true)}/session/chat-save`,
      {
        session_id: threadId,
        message: ReactDOMServer.renderToString(html),
        sender_type: "agent",
      },
      true
    );

    setTimeout(() => {
      scrollToBottom();
      setleadFormStart(true);
      startTakingLead();
    }, 500);
  };

  const zoomBox = () => {
    chatboxRef.current.classList.toggle("zoom");
  };

  var mainlogo = "";
  var chatlogo = "";
  switch (token) {
    case "essco":
      mainlogo = "/agent/essco.png";
      chatlogo =
        "https://www.esscobathware.com/image/catalog/icons/esscofavicon.png";
      break;
    case "haier":
      mainlogo = "/agent/agent/haier_logo_new.png";
      chatlogo = "/agent/agent/haier_white_logo.png";
      break;
    case "glen":
      mainlogo = "/agent/glogo.png";
      chatlogo =
        "https://glenindia.com/cdn/shop/files/Mask_Group_32x32_19424615-95c8-46d8-be5a-2c0f5c8fa21f.webp?v=1726301148";
      break;
    case "acer":
      mainlogo = "https://static-ecapac.acer.com/media/logo/default/acer.png";
      chatlogo =
        "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIACAAIAMBEQACEQEDEQH/xAAZAAEAAgMAAAAAAAAAAAAAAAAAAwYCBQf/xAAjEAABAwMEAwEBAAAAAAAAAAABAgMEABESBSEiMQZBkRQH/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AO40CgUCggmyBEiuPqbW4EC+KLXP0gfTQV2J53pM2Y7AhtS5GotHnDZbC1pTYHIqBKAOQ3y727oMJn9D0CFHalynJDcF1SkIlFq6VKSDcBI5EcTyCcdu6Cw6bOM9lTphyotlWCZKAlSha9wATtv7oINc0WLrbMduUp1BjvB9pTZHFYBANiCD2ewaDVRvCdPiTnp8OXPjzZAtJkNupyfHoKBTjt6sBagwj+BaRHhfgaclJghSCI2SMbIWlYBOOShdI7J2oLVQKBQKBQf/2Q==";
      break;
    case "raymond":
      mainlogo = "/agent/myraymond.png";
      chatlogo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAMFBMVEVHcEzsGTvtGjvsGTrsGTvsGTrsGTrsGTvsGjvsGjrsGTrsGTvsGTrsGTvsGTvsGTvpB37wAAAAD3RSTlMAMg3QWu+vrR/kvnmVSmrZiMMBAAAAuElEQVQokcWRyQ7DIAxEsQ0N+/z/39YhbFGlKqd2DvZILxmwMeZvolS9FhUZX7UscQ5CbFgA0UYSMk+YAX/2AzjO7oE8MwXBdPhqJkBGclF/h/p1eQI11t2hW7EmAWWHBUhrlCrO8oBsndQ1ynl7W/iCXKy/LcjGkGn8STm8ymKpDz3O1F63JYB2SFi3te4TBvsFuseQOxyvssPYTMQ0A3J20samqGr5Xlx/bl/tZXgWXWG9r+lnegN3tQkF+Fwt6wAAAABJRU5ErkJggg==";
      break;
    case "hdfc":
      mainlogo = "https://cdn.worldvectorlogo.com/logos/hdfc-bank-logo.svg";
      chatlogo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAErCAMAAABTpk7/AAAAPFBMVEXtIyrtIyr/+fr////tIyoATI/tICf2io394uOmwNjj7PP5r7L3nJ/tJCv0dXnvPUPvPEIlZp8gYp33nqFf5xrdAAAAA3RSTlPm7/OqSyRJAAACg0lEQVR42u3dUXKDIABFUSQWaayatPvfa7sC0zBo0Jy3AfTM/WQ0hDaW48pyIw8ZumnqX77pli8ry0t6/SP2Uxe6voGl9rH+BgsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCVYiVau8B1q36gbthpeWr9sa4hhXH2uf9zGkvrOFy+A2w2sNKsJSlLGUpS1nKgqUsZSlLWcpSFixlKUtZylKWsmApS1nKUpaylAVLWcpSlrKUpSxYylKWspSlLGXBUpaylKUsZSkLlrKUpSxlKUtZsDYv63Ozna+s6/1jo92vpytrO6zvq7LOgaUsZSlLWcpSFixlKUtZylKWsmApS1nKUpaylAVLWcpSlrKUpSxY71xWwWf6T4H1/LowF2w8PtZY8t4h7nQhqjGskkVYsGDBggULFixYsGDBggULFixYsGDBggULFixYsGDBggULFqxDYQ0FO8MtmpL3Dl1yme2fr+3mnzul7WApS1nKUpaylAVLWcpSlrKUpSxYylKWspSlLGXBUpaylKUsZSkLlrKU1VJZG/7R6XxlNTZ/oVOWspQFS1nKUpaylKUsWMpSlrKUpSxlwVKWspSlLGUpC5aylKUsZSlLWbCUpSxlKUtZyoKlLGUpS1nKUhYsZSlLWcpSlrJgKUtZylLW0cuax+pb/TtErH/evBtWmiqvX/IaVl762gcWWJVh1V+6PcBKLTwlLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWLFiwYMGCBQsWrKew2tiS48ry0sZT/gK1GT1T9xBA1AAAAABJRU5ErkJggg==";
      break;
    case "traya":
      mainlogo = "https://traya.health/cdn/shop/files/Traya_Logo_f6bd592d-1eed-4a4f-8933-63838602ede6.jpg?v=1611833411";
      chatlogo =
        "https://traya.health/cdn/shop/files/favicon-32x32_256x256_1a53794d-d934-47fc-824d-b0e3862279e9.webp?crop=center&height=32&v=1665046231&width=32";
      break;
    default:
      mainlogo = "/agent/myraymond.png";
      chatlogo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAMFBMVEVHcEzsGTvtGjvsGTrsGTvsGTrsGTrsGTvsGjvsGjrsGTrsGTvsGTrsGTvsGTvsGTvpB37wAAAAD3RSTlMAMg3QWu+vrR/kvnmVSmrZiMMBAAAAuElEQVQokcWRyQ7DIAxEsQ0N+/z/39YhbFGlKqd2DvZILxmwMeZvolS9FhUZX7UscQ5CbFgA0UYSMk+YAX/2AzjO7oE8MwXBdPhqJkBGclF/h/p1eQI11t2hW7EmAWWHBUhrlCrO8oBsndQ1ynl7W/iCXKy/LcjGkGn8STm8ymKpDz3O1F63JYB2SFi3te4TBvsFuseQOxyvssPYTMQ0A3J20samqGr5Xlx/bl/tZXgWXWG9r+lnegN3tQkF+Fwt6wAAAABJRU5ErkJggg==";
      break;
  }

  // console.log("🚀 ~ Chatbox ~ sessionData:", sessionData);
  // console.log("🚀 ~ Chatbox ~ messages:", messages);

  return (
    <div className="chatbox-wrapper">
      {isOpen ? (
        <>
          <div className="chatbox-message-wrapper" ref={chatboxRef}>
            <div className="zoom-button" onClick={() => zoomBox()}>
              <img src="/agent/fullscreen.svg" />
            </div>
            <div className="phone-button" onClick={() => submitContact()}>
              <img src={PhoneIcon} />
            </div>
            <div
              className="close-button"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <i className="bx bx-x"></i>
            </div>
            <img src={HeaderBG} className="header-icon" />
            <div className="chatbox-message-header">
              <div className="chatbox-message-profile">
                <img src={mainlogo} alt="" className="chatbox-message-image" />
              </div>
            </div>
            {loader ? (
              <div className="chatbox-message-content loader">
                <img src="/agent/loader.svg" />
              </div>
            ) : (
              <>
                <div
                  className={`chatbox-message-content ${
                    leadFormStart ? "m-content" : ""
                  }`}
                  ref={contentRef}
                >
                  {messages.length === 0 ? (
                    <div className={`chatbox-message-item received`}>
                      <img
                        src={chatlogo}
                        alt=""
                        className="chatbox-message-image av-image"
                      />

                      <div
                        className="chatbox-message-item-text"
                        dangerouslySetInnerHTML={{
                          __html: getMessage(token),
                        }}
                      />

                      {token === "essco" || token === "trayo" ? (
                        <QuestionsNew
                          message={message}
                          setMessage={setMessage}
                          handleSendMessage={handleSendMessage}
                          token={token}
                          setMessages={setMessages}
                          getCurrentTime={getCurrentTime}
                          sessionData={sessionData}
                          threadId={threadId}
                          scrollToBottom={scrollToBottom}
                        />
                      ) : (
                        <Questions
                          token={token}
                          message={message}
                          setMessage={setMessage}
                          handleSendMessage={handleSendMessage}
                        />
                      )}
                    </div>
                  ) : (
                    messages.map((msg, index) => (
                      <div
                        key={index}
                        className={`chatbox-message-item ${msg.type}`}
                      >
                        {msg.type === "sent" ? null : (
                          <img
                            src={chatlogo}
                            alt=""
                            className="chatbox-message-image av-image"
                          />
                        )}

                        {msg.type === "sent" ? (
                          <div className="chatbox-message-item-text">
                            {msg.text}
                          </div>
                        ) : (
                          <ChatAnswer msg={msg} urlenv={urlenv} token={token} />
                        )}

                        {msg.lead ? (
                          <Input
                            data={msg}
                            leadArr={leadArr}
                            setMessages={setMessages}
                            messages={messages}
                            startTakingLead={startTakingLead}
                            token={token}
                            threadId={threadId}
                            urlenv={urlenv}
                          />
                        ) : null}

                        {/* <span className="chatbox-message-item-time">
                          {msg.time}
                        </span> */}
                      </div>
                    ))
                  )}
                </div>

                {leadFormStart ? null : (
                  <div className="chatbox-message-bottom">
                    {isTyping && (
                      <div className="thinking">
                        <img src="/agent/loading.gif" /> AI is Thinking
                      </div>
                    )}
                    <form
                      className="chatbox-message-form"
                      onSubmit={handleSendMessage}
                    >
                      <input
                        rows="1"
                        placeholder={
                          token === "glen"
                            ? "Let's talk ..."
                            : "Go ahead, ask anything else..."
                        }
                        className="chatbox-message-input"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <button type="submit" className="chatbox-message-submit">
                        <img src={SendIcon} />
                      </button>
                    </form>
                    <div className="powered-by">
                      <div>
                        <span>
                          Our AI is evolving. It can occasionally make mistakes.
                        </span>
                      </div>
                      {/* <div>
                        <span>Powered by &nbsp;&nbsp;&nbsp;</span>
                        <img src="/agent/ag.png" style={{ height: 12 }} />
                      </div>
                      <div>
                        <img src="/agent/en.png" />
                        <span>&nbsp;&nbsp;English</span>
                      </div> */}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="overlay" />
        </>
      ) : (
        <div
          className={`chatbox-toggle ${token}-icon`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src={
              token === "essco" || token === "glen"
                ? "/agent/" + token + "-help-2.png"
                : ChatIcon
            }
          />
        </div>
      )}
    </div>
  );
}

export default Chatbox;
